import colors from "core/colors";

export const normalizeHexCode = ({ hexCode }) => {
    if (!hexCode || (hexCode.length === 1 && hexCode === "#")) return "";

    let normalizedHexCode = hexCode;

    normalizedHexCode = normalizedHexCode.replace(/#/g, "");
    normalizedHexCode = normalizedHexCode.toUpperCase();
    normalizedHexCode = `#${normalizedHexCode}`;

    return normalizedHexCode;
};

export const convertHexToRgb = ({ hexCode }) => {
    if (!hexCode) return "";
    return hexCode
        .replace(
            /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
            (m, r, g, b) => "#" + r + r + g + g + b + b
        )
        .substring(1)
        .match(/.{2}/g)
        .map(x => parseInt(x, 16))
        .join(",");
};

export const convertRgbToHex = ({ r, g, b }) => {
    if (!Number.isInteger(r) || !Number.isInteger(g) || !Number.isInteger(b))
        return "";
    return (
        "#" +
        [r, g, b]
            .map(x => {
                const hex = x.toString(16);
                return hex.length === 1 ? "0" + hex : hex;
            })
            .join("")
    );
};

export const convertRgbToNum = ({ rgb }) => {
    const comma = rgb.indexOf(",") > -1 ? "," : "";
    return rgb.split(comma).map(str => parseInt(str));
};

export const isHexCode = code => /^#[0-9A-F]{6}$/i.test(code);

export const isRgbValid = rgbStr =>
    /^(?:(?:^|,\s*)([01]?\d\d?|2[0-4]\d|25[0-5])){3}$/.test(rgbStr);

// this will format from "123,123,123" to "123, 123, 123"
export const formatRgb = str => {
    return str.replace(/[^\d]+/g, ", ");
};

let palette = [
    colors.secondary.onyx,
    "#676767",
    "#9B9B9B",
    "#D3D3D3",
    "#FFFFFF",
    "#FF001C",
    "#FF59B9",
    "#C462DD",
    "#4C25E1",
    "#00449F",
    "#FF824A",
    "#FFB258",
    "#FFD65B",
    "#C3DC64",
    "#71D358",
    "#007435",
    "#00BBC3",
    "#45DEE1",
    "#12B0FB",
    "#3B6BF9"
];

palette = palette.map(color => normalizeHexCode({ hexCode: color }));
export { palette };
